export const checkOwner = (user, owner) => {
  if (user === owner) {
    return true
  }

  return false
}
